import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { Table, Pagination, DatePicker, Button, Modal, Tooltip, Input, Select } from 'components';
import { DeleteIcon, EditIcon, CheckIcon, ExisIcon, PrinterIcon, PasswordInactive, SwitchOffIcon, SwitchOnIcon } from 'assets/icons';
import { AuthService, DoctorService, UserService } from 'services';
import moment from 'moment';
import ModalCreate from './modal-create';
import ModalRate from './modal-rate';
import ModalWork from './modal-work';
import { Globals, Constants, Socket, SocketEvents, checkPermission } from 'utils';
import ModalViewAffiliate from './modal-view-affiliate';

const INITIAL_STATE = {
	since: '',
	until: '',
	search: '',
	status: '',
	state_id: '',
	city_id: '',
	level_id: Constants.LEVELS.AFFILIATE,
	affiliate_type: '',
	verification: '',
}

const AFFILIATE_TYPE_LABELS: { [key: number]: string } = {
	1: 'Médico veterinario',
	2: 'Clínica veterinaria',
	3: 'Comercio'
};
class Affiliate extends React.Component<any> {

	timer: any = undefined;

	state = {
		data: [],
		counter: {
			affiliates: 0,
			businesses: 0,
			clinics: 0,
			medics: 0,
			sellers: 0,
			users: 0,
		},
		page: 1,
		last_page: 1,
		header: [
			'Fecha',
			'Nombres',
			'Documento',
			'Teléfono',
			'Correo',
			'dirección',
			'Estado',
			'Ciudad',
			'Tipo de afiliado',
			'Afiliado por',
			'Verificación',
			'Acción'
		],
		form: INITIAL_STATE,
		visible: false,
		item: null,
		visible_rate: false,
		visible_work: false,
		visible_view: false,
		cities: [],
	}
	componentDidMount() {
		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await UserService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		console.log("respuesta en usuarios", res)
		this.setState({
			data: res.users.rows,
			counter: res.counter,
			last_page: res.users.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		}, () => this.load(true));
	}

	change = (e: any, callback = () => { }) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		}, callback);
	}


	getCities = async () => {
		const res: any = await AuthService.getCities({
			state_id: this.state.form.state_id,
		});
		this.setState({
			cities: res.cities,
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	print = async () => {
		const res: any = await UserService.admin.get({
			withoutLoading: true,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
			download: true,
		});

		if (res.url) {
			const link = document.createElement('a');
			link.href = res.url;
			link.download = res.url.split('/').pop();
			link.target = '_blank';
			link.click();
			link.remove();
		}
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		}, () => this.load(true));
	}

	onCloseRate = () => {
		this.setState({
			visible_rate: false,
			item: null
		}, () => this.load(true));
	}

	onCloseWork = () => {
		this.setState({
			visible_work: false,
			item: null
		}, () => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		}, () => this.load(true));
	}

	delete = async (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el afiliado?', async () => {
			await DoctorService.admin.delete({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	suspend = async (item: any) => {
		Globals.confirm(`¿Desea cambiar el estatus del afiliado a ${item.status == Constants.USER_STATUS.ACTIVE ? 'Suspendido' : 'Activo'}?`, async () => {
			await DoctorService.admin.suspend({
				user_id: item.id
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
		});
	}

	viewRate = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_rate: true,
			item
		});
	}

	viewWork = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_work: true,
			item
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	// NUEVOS MÉTODOS PARA VERIFICACIÓN
	approveVerification = async (item: any) => {
		Globals.confirm('¿Desea aprobar la verificación de este afiliado?', async () => {
			try {
				await UserService.admin.approveOrReject({
					user_id: item.id,
					verification: 1 // Aprobado
				});

				this.load(true);
				Socket.emit(SocketEvents.UPDATE_USER, {
					user_id: item.id
				});
				this.setState({ item: null, visible_view: false });

				Globals.showSuccess('Usuario actualizado exitosamente');

			} catch (err) {
				const error = err as any;

				const errorMessage = error.response?.data?.error
					|| error.message
					|| 'Ocurrió un error inesperado al intentar verificar al usuario.';

				Globals.showError(errorMessage);
				console.error('[Verification Error]', errorMessage);
			}
		});
	}

	rejectVerification = async (item: any) => {
		Globals.confirm('¿Desea rechazar la verificación de este afiliado?', async () => {
			await UserService.admin.approveOrReject({
				user_id: item.id,
				verification: 2 // Rechazado
			});
			this.load(true);
			Socket.emit(SocketEvents.UPDATE_USER, {
				user_id: item.id
			});
			this.setState({ item: null, visible_view: false });
		});
	}

	getVerificationStatusText = (verification: number) => {
		switch (verification) {
			case 0: return 'En revisión';
			case 1: return 'Verificado';
			case 2: return 'Rechazado';
			default: return 'Desconocido';
		}
	}

	getVerificationStatusClass = (verification: number) => {
		switch (verification) {
			case 0: return 'verification-pending';
			case 1: return 'verification-approved';
			case 2: return 'verification-rejected';
			default: return '';
		}
	}

	render() {
		const { counter, visible, visible_work, visible_rate, visible_view } = this.state;

		return (
			<div id="admin-register-doctor">
				<Modal
					className="modal-create-doctor"
					visible={visible}
					withoutClose={true}
					onClose={() => this.onClose()}
				>
					<ModalCreate
						specialities={this.props.specialities}
						item={this.state.item}
						document_types={this.props.document_types}
						phonecodes={this.props.phonecodes}
						states={this.props.states}
						onClose={() => this.onClose()} />
				</Modal>

				<Modal
					className="modal-users-rate"
					visible={visible_rate}
					withoutClose={true}
					onClose={() => this.onCloseRate()}
				>
					{/*
					// @ts-ignore */}
					<ModalRate
						item={this.state.item}
						onClose={() => this.onCloseRate()} />
				</Modal>

				<Modal
					className="modal-users-work"
					visible={visible_work}
					withoutClose={true}
					onClose={() => this.onCloseWork()}
				>
					<ModalWork
						item={this.state.item}
						onClose={() => this.onCloseWork()} />
				</Modal>

				<Modal
					className="modal-view-seller"
					visible={visible_view}
					onClose={() => this.onCloseView()}
				>
					<ModalViewAffiliate
						item={this.state.item}
						onApprove={() => this.approveVerification(this.state.item)}
						onReject={() => this.rejectVerification(this.state.item)}
						onClose={() => this.onCloseView()}
					/>
				</Modal>

				<div className="row row-filter mb-3" style={{ alignItems: 'flex-end' }}>
					{/* Buscar */}
					<div className="col-md-2">
						<Input
							value={this.state.form.search}
							name="search"
							label="Buscar por nombre"
							placeholder="Buscar"
							className="input-table"
							onChange={(e: any) => this.change(e)}
						/>
					</div>

					{/* Desde */}
					<div className="col-md-2">
						<DatePicker
							placeholder="Desde"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'since',
										},
									},
								);
							}}
							value={this.state.form.since}
						/>
					</div>

					{/* Hasta */}
					<div className="col-md-2">
						<DatePicker
							placeholder="Hasta"
							onChange={(text: string) => {
								this.change(
									{
										target: {
											value: text,
											name: 'until',
										},
									}
								);
							}}
							value={this.state.form.until}
						/>
					</div>

					{/* Estatus */}
					<div className="col-md-2">
						<Select
							label="Estatus"
							name="status"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.status}
							options={[
								{ value: Constants.USER_STATUS.ACTIVE.toString(), label: 'Activos' },
								{ value: Constants.USER_STATUS.INACTIVE.toString(), label: 'Suspendidos' },
							]}
						/>
					</div>

					{/* Estado */}
					<div className="col-md-2">
						<Select
							label="Estado"
							name="state_id"
							onChange={(e: any) =>
								this.change(e, () => {
									this.setState(
										{
											form: {
												...this.state.form,
												city_id: '',
											},
										},
										() => {
											this.getCities();
										},
									);
								})
							}
							value={this.state.form.state_id}
							options={this.props.states.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>

					{/* Ciudad */}
					<div className="col-md-2">
						<Select
							label="Ciudad"
							disabled={!this.state.form.state_id}
							name="city_id"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.city_id}
							options={this.state.cities.map((i: any) => ({
								value: i.id,
								label: i.name,
							}))}
						/>
					</div>
					<div className="col-md-2 mt-3">
						<Select
							label="Tipo de Afiliado"
							name="affiliate_type"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.affiliate_type}
							options={(this.props.affiliate_types || []).map((typeId: number) => ({
								value: typeId.toString(),
								label: AFFILIATE_TYPE_LABELS[typeId] || 'Desconocido'
							}))}
						/>
					</div>
					<div className="col-md-2">
						<Select
							label="Estatus de verificación"
							name="verification"
							onChange={(e: any) => this.change(e)}
							value={this.state.form.verification}
							options={[
								{ value: '0', label: 'En revisión' },
								{ value: '1', label: 'Verificado' },
								// { value: '2', label: 'Rechazado' },
							]}
						/>
					</div>

					<div className="col-md-3 filter-actions mt-3" style={{ paddingBottom: '1rem' }}>
						<div style={{ display: 'flex', gap: '10px' }}>
							<Button className="btn-filter" onClick={() => this.load(true)}>
								Filtrar
							</Button>

							{this.state.form !== INITIAL_STATE && (
								<Button className="btn-clean" onClick={this.reset}>
									Limpiar
								</Button>
							)}
						</div>
					</div>
				</div>

				{this.props.tabs}

				<p className="text-right">Afiliado: { counter?.affiliates || 0 } | Comercio: { counter?.businesses || 0 } | Médico veterinario: { counter?.medics || 0 } | Clínica: { counter?.clinics || 0 }</p>

				<Table title="Historial de Registro" data={this.state.data.length} header={this.state.header} rightAlign={[9]} titleRight={
					<React.Fragment>
						{
							checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
								<Button className="btn-add" onClick={() => this.print()}>
									<img src={PrinterIcon} alt="Descargar Excel" />
									Descargar Excel
								</Button>
							)
						}
					</React.Fragment>
				}>
					{this.state.data.map((i: any, index: number) => {
						return (
							<tr key={index}>
								<td>{moment(i.created_at).format('DD-MM-YYYY')}</td>
								<td>{i.name}</td>
								<td>{i.document_type?.name}{i.document}</td>
								<td>{i.phonecode?.name}-{i.phone}</td>
								<td>{i.email}</td>
								<td>{i.address || '-'}</td>
								<td>{i?.state?.name}</td>
								<td>{i?.city?.name}</td>
								<td>{i.affiliate_type_txt}</td>
								<td>{i.seller?.name || '-'}</td>
								<td>
									<span className={`verification-status ${this.getVerificationStatusClass(i.verification || 0)}`}>
										{this.getVerificationStatusText(i.verification || 0)}
									</span>
								</td>
								<td className="actions">
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={(e: any) => this.view(e, i)}>
											<img src={PasswordInactive} alt="Ver" />
										</a>
									</Tooltip>

									{
										checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={(e: any) => this.edit(e, i)}>
													<img src={EditIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.REGISTER, 'delete', this.props.user) && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={(e: any) => this.delete(e, i)}>
													<img src={DeleteIcon} />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
											<Tooltip title={i.status === Constants.USER_STATUS.ACTIVE ? 'Suspender' : 'Activar'}>
												<img
													style={{ width: 28, height: 28 }}
													src={i.status == Constants.USER_STATUS.ACTIVE ? SwitchOnIcon : SwitchOffIcon}
													onClick={() => this.suspend(i)}
													alt="Suspender/Activar"
												/>
											</Tooltip>
										)
									}

									{/* BOTONES DE VERIFICACIÓN (solo si está en revisión) */}
									{(i.verification === 0 || i.verification === undefined) && checkPermission(Constants.MODULES.REGISTER, 'write', this.props.user) && (
										<React.Fragment>
											<Tooltip title="Aprobar">
												<img onClick={() => this.approveVerification(i)} src={CheckIcon} width="35px" alt="" />
											</Tooltip>
											<Tooltip title="Rechazar">
												<img onClick={() => this.rejectVerification(i)} src={ExisIcon} width="35px" alt="" />
											</Tooltip>
										</React.Fragment>
									)}
								</td>
							</tr>
						)
					})}
				</Table>

				<Pagination
					pages={this.state.last_page}
					active={this.state.page}
					onChange={async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					}} />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Affiliate);